import { render, staticRenderFns } from "./MisRecibos.vue?vue&type=template&id=6d00453c&"
import script from "./MisRecibos.vue?vue&type=script&lang=js&"
export * from "./MisRecibos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports